import React from 'react'
import './index.less'

export default function DeviceWarningInfoItem({
  warningInfo = {},
  index,
}) {
  return (
    <div className={`device-warning-info-Item device-warning-level-${(warningInfo.r ? 0 : warningInfo.level)} ${index ? 'active' : ''}`}>
      <div className="dv-title">
        <span className="dv-main-title">{warningInfo.hname}</span>
        <span className="dv-main-title">{warningInfo.t}</span>
        <div className="dv-sub-title">
          <span>{warningInfo.msg}</span>
          <span className={`${warningInfo.r ? '' : 'warning'}`} style={{marginLeft: '50px'}}>{warningInfo.r ? '已解决' : '未解决'}</span>
        </div>
      </div>
    </div>
  )
}